import axiosInstance from "../../../../api/axiosConfig";

export const addSampleCategory = (data: any) => {
  return axiosInstance.post("/admin/sample-categories", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getSampleCategory = (id: string) => {
  return axiosInstance.get(`/admin/sample-categories/${id}`);
};

export const updateSampleCategory = (id: string, data: any) => {
  return axiosInstance.patch(`/admin/sample-categories/${id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
